import { registerSW } from 'virtual:pwa-register'

/**
 * Registra el Service Worker de la PWA.
 * - registerType: 'prompt' → muestra diálogo "Instalar" / "Actualizar" según corresponda.
 * - Al actualizar, recarga la página para aplicar la nueva versión.
 */
export function initPWA() {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (confirm('Hay una nueva versión. ¿Recargar ahora?')) {
        updateSW(true)
      }
    },
    onOfflineReady() {},
    onRegistered() {},
  })
}
